module.exports = "/_next/static/images/5a9663dab6ad06c8e96e33395c94c4d4-mother-and-daugther@0.5x.jpg.webp";